import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const reportsApi = {
  reportList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports`,
      method: 'GET',
      useToken: true,
      title: 'Report - List',
      params,
    }),
  ticketReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reports?type=ticket',
      method: 'GET',
      useToken: true,
      title: 'Report - Ticket',
      params,
    }),

  chartValueReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_VALUE_EVOLUTION}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Chart Value Report',
      params,
    }),

  invoicesList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/invoiceList`,
      method: 'GET',
      useToken: true,
      title: 'Report - Invoices List',
      params,
    }),

  lineDemandReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.LINE_VALUE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Line Demand Report',
      params,
    }),

  lineQuantityReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.LINE_QUANTITY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Line Quantity Report',
      params,
    }),
  kmByDayReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.CAR_KM_BY_DAY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Km by Day Report',
      params,
    }),

  getPassengersAndVehicles: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.PASSENGERS_AND_VEHICLES}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Passengers and Vehicles',
      params,
    }),

  getPassengersAndVehiclesByTrip: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.PASSENGERS_AND_VEHICLES_BY_TRIP}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Passengers and Vehicles By Trip',
      params,
    }),

  getTimedOutEntries: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.TIMED_OUT_ENTRIES}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Timed Out Entries',
      params,
    }),

  getPedestrianEntryByTerminal: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.PEDESTRIAN_ENTRY_BY_TERMINAL}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Pedestrian Entry By Terminal',
      params,
    }),

  segmentDemandReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_SECCIONED}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Line Demand Report',
      params,
    }),
  dailyDemandReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_DAILY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Daily Demand Report',
      params,
    }),

  transportedPassengersByTimeFrame: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.REPORT_ENTRY_BY_HOUR}`,
      method: 'GET',
      useToken: true,
      title: 'Report - transportedPassengersByTimeFrame',
      params,
    }),

  transportedPassengersByTimeFrameByProfile: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.REPORT_ENTRY_BY_HOUR_BY_PROFILE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - transportedPassengersByTimeFrameByProfile',
      params,
    }),

  dailyQuantityReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_QUANTITY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Daily Quantity Report',
      params,
    }),
  dailyQuantitySeccionedReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_SECCIONED_QUANTITY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Daily Quantity Report',
      params,
    }),
  chartEntryReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_VALUE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Chart Entry Report',
      params,
    }),

  chartEntryReportSimplified: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reports',
      method: 'POST',
      useToken: true,
      title: 'Report - Chart Entry Report Simplified',
      data,
    }),

  transportedPassengersReport: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: `/reports`,
      method: 'POST',
      useToken: true,
      title: 'Report - Chart Entry Report Simplified',
      data,
    }),

  heatmapReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_HEATMAP}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Heatmap Report',
      params,
    }),
  paymentReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reports',
      method: 'GET',
      useToken: true,
      title: 'Report - payment Report',
      params,
    }),
  emtuReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.USER_VALUES}`,
      method: 'GET',
      useToken: true,
      title: 'Report - EMTU Report',
      params,
    }),
  generalReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ENTRY_ALL_BY_DAY}`,
      method: 'GET',
      useToken: true,
      title: 'Report - general Report',
      params,
    }),
  travelByLineReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.LINE_KM}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Travel By Line Report',
      params,
    }),
  companyBalanceReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.COMPANY_BALANCE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Company Balance Report',
      params,
    }),
  getScheduleList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reportScheduleList',
      method: 'GET',
      useToken: true,
      title: 'Report - Get Shedule List',
      params,
    }),
  scheduleCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reportScheduleCreate',
      method: 'POST',
      useToken: true,
      title: 'Shedule List - Create',
      data,
    }),
  scheduleUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reportScheduleUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Shedule List - Update',
      data,
    }),
  scheduleDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reportScheduleDelete',
      method: 'GET',
      useToken: true,
      title: 'Report - Shedule Delete',
      params,
    }),
  getPaymentRequestList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_TERMINAL_PAYMENT_REQUEST}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Get Payment Request List',
      params,
    }),

  shipmentByLineRequestList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SHIPMENT_BY_LINE_REPORT_TYPE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Shipment By Line Request List',
      params,
    }),

  transportedPassengersList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.TRANSPORTED_PASSENGERS}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Transported Passengers',
      params,
    }),

  kmDrivedList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.KM_DRIVED}`,
      method: 'GET',
      useToken: true,
      title: 'Report - KM Drived',
      params,
    }),
  getTrips: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripAskMissingEntries',
      method: 'POST',
      useToken: true,
      title: 'tripAskMissingEntries',
      data,
    }),
  emvEntryGet: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/entryGet`,
      method: 'GET',
      useToken: true,
      title: 'Report - EMV Entry GET',
      params,
    }),
  emvEntryGetHistory: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/entryEmvHistoryGet`,
      method: 'GET',
      useToken: true,
      title: 'Report - EMV Entry GET History',
      params,
    }),

  ordersBySchool: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.ORDERS_BY_SCHOOL}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Orders By School',
      params,
    }),

  studentsCardList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.REPORT_STUDENTS_DEVICE}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Students Card List',
      params,
    }),
  gratuitiesList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.FREE_ENTRY_REPORT}`,
      method: 'GET',
      useToken: true,
      title: 'Report - Gratuities List',
      params,
    }),

  reportDurableClient: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reportDurableClient',
      method: 'POST',
      useToken: true,
      title: 'Report - Durable Client',
      data,
    }),

  reportDurableStatus: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reportDurableStatus',
      method: 'GET',
      useToken: true,
      title: 'Report - Durable Status',
      params,
    }),

  reportDurableList: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/reportDurableList',
      method: 'GET',
      useToken: true,
      title: 'Report - Durable List',
      params,
    }),

  reportDurableCancel: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reportDurableCancel',
      method: 'POST',
      useToken: true,
      title: 'Report - Durable Cancel',
      data,
    }),

  reportDurableDelete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/reportDurableDelete',
      method: 'POST',
      useToken: true,
      title: 'Report - Durable Delete',
      data,
    }),

  reportDurableDownload: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reportDurableDownload',
      method: 'GET',
      useToken: true,
      title: 'Report - Durable Download',
      params,
    }),
};

export { reportsApi };
export default reportsApi;
